import axios from "axios";
import { GetLinksByCountry } from "./GetLinksByCountryAction";
import {
  addLinkRequested,
  addLinkRequestSucceeded,
  addLinkRequestFailed,
} from "../slices/AddLinkSlice";

const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Menu/AddLink`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

const getSelectedCountryId = () => {
  const sessionData = localStorage.getItem("sesion");

  if (!sessionData || !selectedCountry) {
    return null;
  }

  const session = JSON.parse(sessionData);
  const country = (session.rols || [])
    .map((entry) => entry.country)
    .find((item) => item?.countryName === selectedCountry);

  return country?.idcountry ?? null;
};

const getSessionUserName = () => {
  const sessionData = localStorage.getItem("sesion");

  if (!sessionData) {
    return "";
  }

  const session = JSON.parse(sessionData);
  return session.employeeId || session.employeeId || "";
};

export const AddLink = (link) => async (dispatch) => {
  try {
    dispatch(addLinkRequested());

    const postData = {
      name: link.name,
      url: link.url,
      isActive: link.isActive ?? true,
      createdBy: getSessionUserName(),
      idLevel1: Number(link.idLevel1),
      idLevel2: Number(link.idLevel2),
      idCountry: Number(getSelectedCountryId()),
    };

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(apiUrl, postData, axiosConfig);

    if (response.data === true) {
      dispatch(addLinkRequestSucceeded(response.data));
      await dispatch(GetLinksByCountry());
      return { success: true, message: "Link created successfully" };
    }

    const errorMessage = "The link could not be created. Please try again.";
    dispatch(addLinkRequestFailed(errorMessage));

    return { success: false, message: errorMessage };
  } catch (error) {
    const errorMessage = error.response?.data || error.message;
    dispatch(addLinkRequestFailed(errorMessage));

    return {
      success: false,
      message: errorMessage,
    };
  }
};
